import React from 'react';
import { Brain } from '@phosphor-icons/react';
import Footer from '@/components/Footer';
import UnifiedFederationHub from '@/components/UnifiedFederationHub';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#030305]">
      {/* Coinlib Ticker */}
      <div className="w-full" data-testid="coinlib-ticker">
        <iframe
          src="https://widget.coinlib.io/widget?type=horizontal_v2&theme=light&pref_coin_id=1505"
          width="100%"
          height="36"
          frameBorder="0"
          scrolling="auto"
          title="Crypto Ticker"
        />
      </div>

      {/* Header — brand only; navigation lives in the static Federation Pillars master menu */}
      <header className="glass-surface border-b border-white/10 sticky top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-center">
          <a href="/" className="flex items-center gap-2 sm:gap-3" data-testid="logo-link">
            <Brain size={28} weight="duotone" className="neon-cyan sm:w-8 sm:h-8" />
            <div>
              <h1 className="text-base sm:text-xl font-bold neon-cyan" spellCheck={false}>NextXus</h1>
              <p className="text-[10px] sm:text-xs text-gray-400 mono">Echo v2.1 Portal</p>
            </div>
          </a>
        </div>
      </header>

      {/* Main Content */}
      <main>{children}</main>

      {/* Unified Federation Hub */}
      <UnifiedFederationHub />

      {/* 4-Column Intelligent Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
